<template>
	<div>
		<loading :active.sync="isLoading"></loading>
		<div class="row" v-if="row">
			<div class="col-12">
				<div class="row p-3">
					<div class="col-12 text-left">
						<ul class="list-group element-box mb-4 px-2">
							<li class="list-group-item"><strong>{{ t.finance.bank }}:</strong> {{ row.bank.name }} <router-link class="pull-right" :to="{ name: 'bank_account_edit', params: { id: row.id } }"><i class="os-icon os-icon-pencil-1"></i> {{ t.edit }}</router-link></li>
							<li class="list-group-item"><strong>{{ t.finance.currency }}:</strong> {{ row.currency.iso_code }} ({{ row.currency.symbol }})</li>
							<li class="list-group-item"><strong>{{ t.bank_account.account_owner }}:</strong> {{ row.owner_name }} </li>
							<li class="list-group-item"><strong>{{ t.bank_account.iban }}:</strong> {{ row.iban }} </li>
							<li class="list-group-item"><strong>{{ t.bank_account.identifier }}:</strong> {{ row.identifier }}</li>
							<li class="list-group-item"><strong>{{ t.bank_account.swift }}:</strong> {{ row.swift_code }}</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
        name: 'bankAccountDetail',
        props: {
            id: {
                default: 0
            }
        },
        data () {
            return {
                api: window.api,
                t: this.$root.t,
                row: null,
                status: 0,
                isLoading: false,
            }
        },
        mounted () {
            this.fetchData();
        },
        methods: {
            fetchData () {
                this.isLoading = true;
                this.$http.get(api+'api/v1/bankAccount/'+this.id).then(
                    response => {
                    // get body data
                this.row = response.body.result.bank_account;
                this.isLoading = false;
                this.status = response.status;

            }, response => {
                    this.isLoading = false;
                    this.status = response.status;
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	ul,li {
		list-style: none;
	}
</style>



// WEBPACK FOOTER //
// src/components/accounting/BankAccountDetail.vue